import {
    SET_NOTIFICATIONS_MODAL,
    GET_ALL_NOTIFICATIONS_BEGIN, GET_ALL_NOTIFICATIONS_SUCCESS, GET_ALL_NOTIFICATIONS_FAILURE,
    POST_NOTIFICATION_BEGIN, POST_NOTIFICATION_SUCCESS, POST_NOTIFICATION_FAILURE,
    PUT_NOTIFICATION_BEGIN, PUT_NOTIFICATION_SUCCESS, PUT_NOTIFICATION_FAILURE,
    DELETE_NOTIFICATION_BEGIN, DELETE_NOTIFICATION_SUCCESS, DELETE_NOTIFICATION_FAILURE
} from '../constants/ActionTypes'

const initialState = {
    currentNofificationsModal: null,

    notifications: null,
    notificationsError: null,
    loadingNotifications: false,

    createNotificationError: null,
    creatingNotification: false,

    editNotificationError: null,
    editingNotification: false,

    deleteNotificationError: null,
    deletingNotification: false
}

const ReducerNotification = (state = initialState, { payload, type }) => {

    switch (type) {

        case SET_NOTIFICATIONS_MODAL: {
            return {
                ...state,
                currentNofificationsModal: payload
            }
        }

        case GET_ALL_NOTIFICATIONS_BEGIN: {
            return {
                ...state,
                notifications: null,
                notificationsError: null,
                loadingNotifications: true
            }
        }

        case GET_ALL_NOTIFICATIONS_SUCCESS: {
            return {
                ...state,
                notifications: payload.response,
                notificationsError: null,
                loadingNotifications: false
            }
        }

        case GET_ALL_NOTIFICATIONS_FAILURE: {
            return {
                ...state,
                notifications: null,
                notificationsError: payload,
                loadingNotifications: false
            }
        }

        case POST_NOTIFICATION_BEGIN: {
            return {
                ...state,
                createNotificationError: null,
                creatingNotification: true
            }
        }

        case POST_NOTIFICATION_SUCCESS: {
            return {
                ...state,
                createNotificationError: null,
                creatingNotification: false
            }
        }

        case POST_NOTIFICATION_FAILURE: {
            return {
                ...state,
                createNotificationError: payload,
                creatingNotification: false
            }
        }

        case PUT_NOTIFICATION_BEGIN: {
            return {
                ...state,
                editNotificationError: null,
                editingNotification: true
            }
        }

        case PUT_NOTIFICATION_SUCCESS: {
            return {
                ...state,
                editNotificationError: null,
                editingNotification: false
            }
        }

        case PUT_NOTIFICATION_FAILURE: {
            return {
                ...state,
                editNotificationError: payload,
                editingNotification: false
            }
        }

        case DELETE_NOTIFICATION_BEGIN: {
            return {
                ...state,
                deleteNotificationError: null,
                deletingNotification: true
            }
        }

        case DELETE_NOTIFICATION_SUCCESS: {
            return {
                ...state,
                deleteNotificationError: null,
                deletingNotification: false
            }
        }

        case DELETE_NOTIFICATION_FAILURE: {
            return {
                ...state,
                deleteNotificationError: payload,
                deletingNotification: false
            }
        }

        default: return state

    }

}

export default ReducerNotification